var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.templateArgs.lectors),function(lector,index){return _c('div',{key:index},[_c('p',[_vm._v(_vm._s(lector.fullName))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }